import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Media from 'react-media';
import GlobalTheme, { breakpointValues } from '../../../../styled/GlobalTheme';
import PiperTip from '../../../../components/PiperTips/PiperTip';
import Pipers from '../../../../components/Pipers/Pipers';
import { tutorialModal } from '../../../../assets/illustrations/illustrationRepository';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${GlobalTheme.breakpoints.down('sm')}{
   flex-direction: column;
  }
  @media (max-height: 425px) {
    padding: 10px;
  }
`;

const PiperTipWrapper = styled.div`
  ${GlobalTheme.breakpoints.down('sm')}{
    display: none;
  }
  @media (max-height: 425px) {
    margin-right: 20px;
  }
`;

const ImageBox = styled.div`
  ${({ hasPiperTip }) => (hasPiperTip ? 'width: 396px;' : '')}
  ${GlobalTheme.breakpoints.down('md')}{
    width:${({ hasPiperTip }) => (hasPiperTip ? '396' : '500')}px;
  }
  ${GlobalTheme.breakpoints.down('sm')}{
    height: 240px;
    width: 200px;
  }
  @media (max-height: 425px) {
    ${({ hasPiperTip }) => (hasPiperTip ? 'width: 100px' : 'height: 30vh;')}
  }
`;

const Image = styled.img`
  width: 100%; 
  height: 100%; 
  object-fit: contain;
`;

const PiperTipStyled = styled(PiperTip)`
  && {
    @media (max-height: 425px) {
        display: none;
      }
    }
  }
`;

const PiperImage = styled.img`
  display: none;
  @media (max-height: 425px) {
    display: block;
    width: 70px;
  }
`;

const BodySlider = ({ images, hasPiperTip }) => {
  const intl = useIntl();
  const piperImage = intl.locale === 'es' ? tutorialModal.piperHelloEs : tutorialModal.piperHelloEn;
  return (
    <Media queries={{
      sm: `(max-width: ${breakpointValues.md - 1}px)`,
      md: `(max-width: ${breakpointValues.lg - 1}px)`,
      lg: `(min-width: ${breakpointValues.lg}px)`,
    }}
    >
      {(matches) => {
        let image = images.lg;
        if (matches.md) image = images.md;
        if (matches.sm) image = images.sm;
        return (
          <Container>
            {hasPiperTip && (
              <PiperTipWrapper>
                <PiperImage src={piperImage} />
                <PiperTipStyled
                  position="top"
                  Piper={Pipers.Piper1}
                  piperWidth={matches.md ? '100px' : '125px'}
                  trianglePosition="bottom"
                  minHeightTip="0px"
                >
                  <FormattedMessage
                    id="tutorialModal.piperTip"
                    defaultMessage="Hi! I'm Piper"
                  />
                </PiperTipStyled>
              </PiperTipWrapper>
            )}
            <ImageBox hasPiperTip={hasPiperTip}>
              <Image
                src={image}
              />
            </ImageBox>
          </Container>
        );
      }}
    </Media>
  );
};

BodySlider.propTypes = {
  images: PropTypes.shape({
    lg: PropTypes.string,
    md: PropTypes.string,
    sm: PropTypes.string,
  }).isRequired,
  hasPiperTip: PropTypes.bool.isRequired,
};

export default BodySlider;
